import { useEffect } from "react";

/** Hide CRA/Webpack dev error overlay (iframe and div forms).
 *  The overlay only exists in dev builds; in production this is a no-op.
 */
export default function useSuppressDevOverlay() {
  useEffect(() => {
    // Inject a global CSS rule that hides known dev overlay containers.
    const STYLE_ID = "cl-suppress-dev-overlay";
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = `
        iframe#webpack-dev-server-client-overlay,
        iframe[id*="webpack-dev-server"],
        iframe[id*="error-overlay"],
        div#webpack-dev-server-client-overlay-div,
        div[id*="webpack-dev-server"],
        div[id*="error-overlay"],
        div[data-react-dev-overlay],
        .react-error-overlay,
        #react-refresh-overlay {
          display: none !important;
          visibility: hidden !important;
          pointer-events: none !important;
          opacity: 0 !important;
        }
      `;
      document.head.appendChild(style);
    }

    const hide = () => {
      // Brute-force: any iframe/div with very high z-index near the body root
      const candidates = document.querySelectorAll("body > iframe, body > div");
      candidates.forEach((el) => {
        const id = (el.id || "").toLowerCase();
        if (id.includes("overlay") || id.includes("webpack") || id.includes("error")) {
          el.style.setProperty("display", "none", "important");
        }
      });
    };

    const swallow = (e) => {
      try { e.preventDefault(); e.stopImmediatePropagation(); } catch {}
      hide();
    };

    window.addEventListener("unhandledrejection", swallow, true);
    window.addEventListener("error", swallow, true);
    hide();
    const interval = setInterval(hide, 200);
    const observer = new MutationObserver(hide);
    observer.observe(document.body, { childList: true, subtree: false });

    return () => {
      window.removeEventListener("unhandledrejection", swallow, true);
      window.removeEventListener("error", swallow, true);
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);
}
